import z from 'zod';

export enum ContactMessageState {
  UNREAD = 'UNREAD',
  READ = 'READ',
  ARCHIVE = 'ARCHIVE',
}

export const contactMessageStateSchema = z.enum(ContactMessageState);
